import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/components/LanguageContext";
import ScrollReveal from "@/components/ScrollReveal";
import EN from "@/data/content-en";
import ZH from "@/data/content-zh";
import { PAGE_IMAGES, pathFor } from "@/data/pages";

// PwC-style case-study cards — three columns, image top, title, short desc, "Learn more →"
export default function CaseStudyCards({ ids, viewMoreId }) {
  const { lang, t } = useLang();
  const all = lang === "zh" ? ZH : EN;

  return (
    <section className="bg-white py-20 md:py-24" data-testid="case-study-cards">
      <div className="max-w-[1480px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-14">
          {ids.map((id, idx) => {
            const rel = all[id];
            if (!rel) return null;
            return (
              <ScrollReveal key={id} delay={idx * 70}>
                <Link to={pathFor(id, lang)} className="block group" data-testid={`case-card-${id}`}>
                  <div className="img-frame aspect-square bg-[var(--abs-soft)] mb-7">
                    <img src={PAGE_IMAGES[id]} alt={rel.h1} className="w-full h-full object-cover" />
                  </div>
                  <h3 className="serif text-2xl md:text-[28px] leading-[1.18] text-[var(--abs-ink)] group-hover:text-[var(--abs-orange)] transition-colors">
                    {rel.h1}
                  </h3>
                  <p className="mt-6 text-[15px] leading-[1.7] text-[var(--abs-ink)]">
                    {rel.intro}
                  </p>
                  <div className="mt-7 inline-flex items-center gap-2 text-[var(--abs-ink)] text-[15px] group-hover:text-[var(--abs-orange)] transition-colors">
                    <span>{t.cta.learnMore}</span>
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  </div>
                </Link>
              </ScrollReveal>
            );
          })}
        </div>

        {viewMoreId && (
          <ScrollReveal delay={200}>
            <div className="mt-16">
              <Link
                to={pathFor(viewMoreId, lang)}
                className="inline-flex items-center gap-2 text-[var(--abs-ink)] text-[15px] hover:text-[var(--abs-orange)] transition-colors"
                data-testid="view-more-link"
              >
                <span>{lang === "zh" ? "查看更多服务" : "View more services"}</span>
                <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </ScrollReveal>
        )}
      </div>
    </section>
  );
}
